import angular from 'angular'
import './posts.service'
import './blocked_user_comments/blocked_user_comments.controller'
import './blocked_users/blocked_users.controller'
import './comments/comments.controller'
import './comments/comments.service'
import './edit/edit.controller'
import './logs/logs.controller'
import './logs/logs.service'

angular
  .module('admin.posts', [
    'admin.posts.service',
    'admin.post.comments',
    'admin.post.edit',
    'admin.post.logs',
    'admin.posts.post_blocked_users',
    'admin.posts.post_blocked_user_comments',
  ])
  .controller('PostsAdminCtrl', PostsAdminCtrl)

/** @ngInject */
function PostsAdminCtrl(
  $scope,
  $q,
  $state,
  $sce,
  $rootScope,
  $stateParams,
  UserCache,
  PostsAdminService,
  CacheService,
  UploadService,
) {
  var vm = this
  vm.itemsDraft = []
  vm.itemsPublished = []
  vm.readyOnly = false

  vm.pathImgT = ''
  vm.pathImgH = ''
  vm.create = false
  vm.model = {}
  vm.usersPerPage = 25

  vm.sortType = 'n-asc'
  vm.sortReverse = false
  vm.sortType2 = 'ts-p-desc'
  vm.sortReverse2 = false

  function reloadPaginationDraft() {
    vm.totalUsers = 0
    vm.oldPage = 0
    vm.currentPage = 25
    vm.first = true
    vm.totalItems = 0
    vm.pagination = {
      current: 1,
    }
  }

  function reloadPaginationPublish() {
    vm.totalUsers2 = 0
    vm.oldPage2 = 0
    vm.currentPage2 = 25
    vm.first2 = true
    vm.totalItems2 = 0
    vm.pagination2 = {
      current: 1,
    }
  }

  reloadPaginationDraft()
  reloadPaginationPublish()

  loadDraft(1)
  loadPublished(1)

  var tab = localStorage.getItem('tabadmin')
  if (tab !== null) {
    if (tab === 'draft') {
      $('#published').removeClass('active')
      $('#draft').addClass('active')
      $('#drafttab').addClass('active')
    } else if (tab === 'published') {
      $('#draft').removeClass('active')
      $('#published').addClass('active')
      $('#publishedtab').addClass('active')
    }
  } else {
    $('#draft').addClass('active')
    $('#drafttab').addClass('active')
  }
  var oldSortType, oldSortType2

  function loadDraft(pageNumber) {
    if (pageNumber === 1) {
      vm.pagination.current = 1
    }
    if (!vm.first) {
      vm.currentPage = pageNumber * 25
      vm.oldPage = vm.currentPage - 25
    } else {
      vm.first = false
    }

    oldSortType = angular.copy(vm.sortType)
    PostsAdminService.listDraft(vm.oldPage, 25, vm.sortType).then(function (result) {
      var posts = result.results
      if (vm.totalItems === 0) {
        vm.totalItems = result.ct
      }
      for (var i = 0; i < posts.length; i++) {
        posts[i].status = 'Draft'
        posts[i].editing = false
        posts[i].loadT = false
        posts[i].loadH = false
        if (posts[i]['ts-p'] !== undefined) {
          posts[i].isPub = true
          posts[i]['ts-p'] = new Date(
            parseInt(
              posts[i]['ts-p'].toString().substring(0, posts[i]['ts-p'].toString().length - 3),
            ),
          )
          if (posts[i]['ts-p'] > new Date()) {
            posts[i].status = 'Pending'
          }
        } else {
          posts[i].isPub = false
        }
        posts[i].ts = new Date(
          parseInt(posts[i].ts.toString().substring(0, posts[i].ts.toString().length - 3)),
        )

        if (posts[i]['img-h'].indexOf('mp4') !== -1 || posts[i]['img-h'].indexOf('mov') !== -1) {
          posts[i].isVideo = true
          posts[i].video = $sce.trustAsResourceUrl($rootScope.urlS3 + '/posts/' + posts[i]['img-h'])
        } else {
          posts[i].isVideo = false
        }
      }

      vm.itemsDraft = posts
      vm.sortType = oldSortType
      vm.disableTable = false
    })
  }

  vm.pageChangedDraft = function (newPage) {
    vm.sortType = oldSortType
    loadDraft(newPage)
    $('html, body').animate({ scrollTop: 0 }, 0)
  }

  function loadPublished(pageNumber) {
    if (pageNumber === 1) {
      vm.pagination2.current = 1
    }
    if (!vm.first2) {
      vm.currentPage2 = pageNumber * 25
      vm.oldPage2 = vm.currentPage2 - 25
    } else {
      vm.first2 = false
    }

    oldSortType2 = angular.copy(vm.sortType2)
    PostsAdminService.listPublished(vm.oldPage2, 25, vm.sortType2).then(function (result) {
      var posts = result.results
      if (vm.totalItems2 === 0) {
        vm.totalItems2 = result.ct
      }
      for (var i = 0; i < posts.length; i++) {
        posts[i].editing = false
        posts[i].loadT = false
        posts[i].loadH = false
        if (posts[i]['ts-p'] !== undefined) {
          posts[i].isPub = true
          posts[i]['ts-p'] = new Date(
            parseInt(
              posts[i]['ts-p'].toString().substring(0, posts[i]['ts-p'].toString().length - 3),
            ),
          )
        } else {
          posts[i].isPub = false
        }
        posts[i].ts = new Date(
          parseInt(posts[i].ts.toString().substring(0, posts[i].ts.toString().length - 3)),
        )

        if (posts[i]['img-h'].indexOf('mp4') !== -1 || posts[i]['img-h'].indexOf('mov') !== -1) {
          posts[i].isVideo = true
          posts[i].video = $sce.trustAsResourceUrl($rootScope.urlS3 + '/posts/' + posts[i]['img-h'])
        } else {
          posts[i].isVideo = false
        }
      }

      vm.itemsPublished = posts
      vm.sortType2 = oldSortType2
    })
  }

  vm.pageChangedPublished = function (newPage) {
    vm.sortType2 = oldSortType2
    loadPublished(newPage)
    $('html, body').animate({ scrollTop: 0 }, 0)
  }

  vm.tabDraft = function () {
    $('#published').removeClass('active')
    $('#draft').addClass('active')
    localStorage.setItem('tabadmin', 'draft')
  }

  vm.tabPublished = function () {
    $('#draft').removeClass('active')
    $('#published').addClass('active')
    localStorage.setItem('tabadmin', 'published')
  }

  vm.add = function () {
    $state.go('admin.posts.edit', { id: 0 })
  }

  vm.edit = function (item) {
    $state.go('admin.posts.edit', { id: item.id })
  }

  vm.delete = function (item) {
    swal(
      {
        title: 'Are you Sure?',
        text: '',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: 'slide-from-top',
      },
      function (isConfirm) {
        if (isConfirm) {
          if (item['ts-p'] !== undefined || item['ts-p'] !== null) {
            PostsAdminService.update(item.id, { 'ts-p': null }).then(function () {
              PostsAdminService.remove(item.id).then(function () {
                $state.reload()
              })
            })
          } else {
            PostsAdminService.remove(item.id).then(function () {
              $state.reload()
            })
          }
        } else {
          return
        }
      },
    )
  }

  vm.publish = function (item) {
    PostsAdminService.publish(item.id).then(function () {
      $state.reload()
    })
  }

  vm.unpublish = function (item) {
    PostsAdminService.unpublish(item.id).then(function () {
      $state.reload()
    })
  }

  vm.uploadT = function (item) {
    item.loadT = true
    UploadService.save('posts', vm.pathImgT, 'img-t', item.id).then(function (fileName) {
      item.loadT = false
      item['img-t'] = fileName
    })
  }

  vm.uploadH = function (item) {
    item.loadH = true
    UploadService.save('posts', vm.pathImgH, 'img-h', item.id).then(function (fileName) {
      item.loadH = false
      item['img-h'] = fileName
    })
  }

  vm.clone = function (item, type) {
    if (type === 2) {
      swal('User posts cannot be cloned', '', 'error')
      return
    }

    var clone = {
      t: item.t,
      txt: item.txt,
      url: item.url,
      urlt: item.urlt,
      'img-h': item['img-h'],
      'id-ch': item['id-ch'],
      k: item.k,
      n: 1,
    }

    if (type === 3) {
      var cache = UserCache.getObject()
      var userId = cache.user.id
      clone['id-a'] = userId
    }

    PostsAdminService.save(clone).then(function (result) {
      toastr.success('Cloned!')
      vm.sortType = 'n-asc'
      vm.sortReverse = false
      vm.sortType2 = 'ts-p-desc'
      vm.sortReverse2 = false
      loadDraft(vm.pagination.current)
      loadPublished(vm.pagination2.current)
    })
  }

  vm.back = function () {
    loadDraft(vm.pagination.current)
    loadPublished(vm.pagination2.current)
  }

  vm.showDescription = function (item) {
    $('#myModal').modal('show')
    $('#myModal').on('shown.bs.modal', function () {
      $('#description').html(item)
    })
  }

  vm.showTags = function (tags) {
    $('#myModal').modal('show');
    $('#myModal').on('shown.bs.modal', function () {
      let html = '';

      tags.forEach(function (tag) {
        html += `<span style="
          display:inline-block;
          margin:3px;
          padding:5px 10px;
          background:#e5e7eb;
          color:#374151;
          border-radius:4px;
        ">${tag.name}</span>`;
      });

      $('#description').html(html);
    });
  }

  vm.sort = function (type, isTab) {
    if (isTab === 1) {
      vm.sortReverse = !vm.sortReverse
      if (vm.sortReverse) {
        vm.sortType = type + '-asc'
      } else {
        vm.sortType = type + '-desc'
      }
      loadDraft(vm.pagination.current)
    } else {
      vm.sortReverse2 = !vm.sortReverse2
      if (vm.sortReverse2) {
        vm.sortType2 = type + '-asc'
      } else {
        vm.sortType2 = type + '-desc'
      }
      loadPublished(vm.pagination2.current)
    }
  }

  vm.disableTable = false
  vm.barConfig = {
    animation: 350,
    onEnd: function (/** ngSortEvent */ evt) {
      vm.disableTable = true
      var newIdx = parseInt(evt.newIndex) + 1
      PostsAdminService.reorder(evt.model.id, newIdx).then(function () {
        vm.sortType = 'n-asc'
        vm.sortReverse = false
        loadDraft(vm.pagination.current)
      })
    },
  }

  vm.update = function (model, reload, cb) {
    PostsAdminService.update(model.id, { n: model.n }).then(function () {
      if (reload) {
        vm.sortType = 'n-asc'
        vm.sortReverse = false
        loadDraft(vm.pagination.current)
      }

      cb()
    })
  }

  vm.openImage = function (item) {
    if (item.isVideo) {
      window.open(item.video, '_blank')
    } else {
      window.open($rootScope.urlS3 + '/posts/' + item['img-h'], '_blank')
    }
  }
}
